import * as angular from "angular";
import { Constants as constants } from "../../constants";
import { ProviderRepo as providerRepo } from "./fileprovider.repo";
import { fileList } from "./fileList";
import { fileInfo } from "./viewFile/fileInfo";
import { newFile } from "./newFile/newFile";

export const filesModule = "fileprovider";

angular
  .module(filesModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService",
  ])
  .constant("config", constants.Default)
  .service("providerRepo", providerRepo)
  .component("fileList", fileList)
  .component("fileInfo", fileInfo)
  .component("newFile", newFile);



// WEBPACK FOOTER //
// ./src/app/fileprovider/fileprovider.index.ts